/* Lookbook — Shop-the-look quick-view drawer (per-instance).
   Every look/card renders its OWN drawer instance (snippets/lb-quickview-drawer.liquid),
   pre-populated with real products at render time — no shared singleton, no client-side
   template cloning. A trigger carries [data-lb-qv-open] + [data-lb-qv-target="#panel-id-root"]
   and opens exactly that one drawer. Only one drawer is ever open at a time. */
(function () {
  if (window.__lbQuickviewDrawerInit) return;
  window.__lbQuickviewDrawerInit = true;

  var activeRoot = null;
  var lastOpener = null;
  var savedScrollY = 0;

  function formatMoney(cents) {
    cents = Number(cents);
    if (isNaN(cents)) return '';
    var format = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '£{{amount}}';
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = amount.replace(/\.00$/, '');
    var amountWithComma = amount.replace('.', ',');
    var amountWithCommaNoDecimals = amountWithComma.replace(/,00$/, '');
    return format
      .replace('{{amount}}', amountNoDecimals)
      .replace('{{ amount }}', amountNoDecimals)
      .replace('{{amount_with_comma_separator}}', amountWithCommaNoDecimals)
      .replace('{{ amount_with_comma_separator }}', amountWithCommaNoDecimals);
  }

  /* Bags and scarves show their second product image instead of the featured (first) one —
     mirrors the same rule in snippets/mm-ways-product-tile.liquid. Matches on type OR tags,
     case-insensitive. Checks 'scarve' as well as 'scarf' since the plural "Scarves" doesn't
     contain the substring "scarf" (f -> ves), unlike "Bags" which does contain "bag". */
  function pickThumbImage(product) {
    var useSecondImage = false;
    var type = (product.type || '').toLowerCase();
    if (type.indexOf('bag') > -1 || type.indexOf('scarf') > -1 || type.indexOf('scarve') > -1) {
      useSecondImage = true;
    }
    if (!useSecondImage && product.tags) {
      for (var i = 0; i < product.tags.length; i++) {
        var tag = (product.tags[i] || '').toLowerCase();
        if (tag.indexOf('bag') > -1 || tag.indexOf('scarf') > -1 || tag.indexOf('scarve') > -1) {
          useSecondImage = true;
          break;
        }
      }
    }
    if (useSecondImage && product.images && product.images.length > 1) {
      return product.images[1];
    }
    return product.featured_image;
  }

  /* Resolves each row's product client-side via the storefront's direct per-handle route
     (/products/{handle}.js) instead of Liquid's all_products[handle] — that lookup is
     backed by a search index that can return a stale/wrong product for a valid handle,
     and the storefront catalog is too large (1000+ products) to search via a collection
     in Liquid. The per-handle route is an exact-match lookup, so it can't misresolve. */
  function hydrateRow(row, soldOutLabel) {
    var handle = row.getAttribute('data-lb-handle');
    if (!handle || row.getAttribute('data-lb-hydrated')) return;
    row.setAttribute('data-lb-hydrated', 'pending');

    fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Lookbook quick-view: product not found for handle "' + handle + '"');
        return res.json();
      })
      .then(function (product) {
        var variant = null;
        for (var i = 0; i < product.variants.length; i++) {
          if (product.variants[i].available) {
            variant = product.variants[i];
            break;
          }
        }
        if (!variant) variant = product.variants[0];

        var thumb = row.querySelector('.lb-qv-row__thumb');
        var thumbImage = pickThumbImage(product);
        if (thumb && thumbImage) {
          var sep = thumbImage.indexOf('?') > -1 ? '&' : '?';
          var img = document.createElement('img');
          img.src = thumbImage + sep + 'width=160';
          img.alt = product.title;
          img.width = 60;
          img.height = 74;
          img.loading = 'lazy';
          thumb.innerHTML = '';
          thumb.appendChild(img);
        }

        var category = row.querySelector('.lb-qv-row__category');
        if (category) category.textContent = product.type;

        var link = row.querySelector('[data-lb-row-link]');
        if (link) {
          link.setAttribute('href', product.url);
          link.textContent = product.title;
        }

        var price = row.querySelector('.lb-qv-row__price');
        if (price) price.textContent = formatMoney(variant ? variant.price : product.price);

        var wishlistBtn = row.querySelector('.lb-qv-row__wishlist');
        if (wishlistBtn) {
          wishlistBtn.setAttribute('data-product-id', product.id);
          wishlistBtn.setAttribute('data-variant-id', variant ? variant.id : '');
          wishlistBtn.setAttribute('data-product-url', window.location.origin + product.url);
          wishlistBtn.setAttribute('aria-label', 'Add ' + product.title + ' to wishlist');
        }

        var addBtn = row.querySelector('[data-lb-qv-add]');
        if (addBtn) {
          var available = !!(variant && variant.available);
          addBtn.setAttribute('data-variant-id', variant ? variant.id : '');
          addBtn.disabled = !available;
          addBtn.textContent = available ? 'ADD' : soldOutLabel;
        }

        row.setAttribute('data-lb-hydrated', 'true');
      })
      .catch(function (err) {
        /* eslint-disable-next-line no-console */
        console.error(err);
        row.remove();
      });
  }

  function hydrateRoot(root) {
    var soldOutLabel = root.getAttribute('data-lb-sold-out-label') || 'Sold out';
    var rows = root.querySelectorAll('[data-lb-qv-row]:not([data-lb-hydrated])');
    for (var i = 0; i < rows.length; i++) {
      hydrateRow(rows[i], soldOutLabel);
    }
  }

  function focusableEls(panel) {
    return Array.prototype.slice.call(
      panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
    );
  }

  function onKeydown(evt) {
    if (!activeRoot) return;
    if (evt.key === 'Escape') {
      close();
      return;
    }
    if (evt.key !== 'Tab') return;
    var panel = activeRoot.querySelector('.lb-qv-panel');
    if (!panel) return;
    var els = focusableEls(panel);
    if (!els.length) return;
    var first = els[0];
    var last = els[els.length - 1];
    if (evt.shiftKey && document.activeElement === first) {
      evt.preventDefault();
      last.focus();
    } else if (!evt.shiftKey && document.activeElement === last) {
      evt.preventDefault();
      first.focus();
    }
  }

  function open(root, trigger) {
    if (activeRoot && activeRoot !== root) close();

    activeRoot = root;
    lastOpener = trigger;
    hydrateRoot(root);
    if (trigger) {
      trigger.classList.add('is-active');
      trigger.setAttribute('aria-expanded', 'true');
    }

    savedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.style.width = '100%';

    root.classList.add('is-open');
    var panel = root.querySelector('.lb-qv-panel');
    if (panel) panel.setAttribute('aria-hidden', 'false');
    document.addEventListener('keydown', onKeydown);

    window.requestAnimationFrame(function () {
      var closeBtn = panel && panel.querySelector('[data-lb-qv-close]');
      if (closeBtn) closeBtn.focus();
    });
  }

  function close() {
    if (!activeRoot) return;
    var root = activeRoot;
    root.classList.remove('is-open');
    var panel = root.querySelector('.lb-qv-panel');
    if (panel) panel.setAttribute('aria-hidden', 'true');

    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, savedScrollY);

    document.removeEventListener('keydown', onKeydown);

    if (lastOpener) {
      lastOpener.classList.remove('is-active');
      lastOpener.setAttribute('aria-expanded', 'false');
      if (typeof lastOpener.focus === 'function') {
        lastOpener.focus();
      }
    }
    activeRoot = null;
    lastOpener = null;
  }

  function addToCart(items, triggerBtn) {
    triggerBtn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) {
          return res.json().then(function (err) {
            throw err;
          });
        }
        return res.json();
      })
      .then(function () {
        triggerBtn.classList.remove('is-loading');
        triggerBtn.classList.add('is-added');
        setTimeout(function () {
          triggerBtn.classList.remove('is-added');
        }, 1500);
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      })
      .catch(function (err) {
        triggerBtn.classList.remove('is-loading');
        /* eslint-disable-next-line no-console */
        console.error('Lookbook quick-view: add to cart failed', err);
      });
  }

  document.addEventListener('click', function (evt) {
    var opener = evt.target.closest('[data-lb-qv-open]');
    if (opener) {
      var targetSelector = opener.getAttribute('data-lb-qv-target');
      var root = targetSelector ? document.querySelector(targetSelector) : null;
      if (root) {
        evt.preventDefault();
        open(root, opener);
      }
      return;
    }

    if (evt.target.closest('[data-lb-qv-close]')) {
      close();
      return;
    }

    if (evt.target.closest('[data-lb-qv-scrim]')) {
      close();
      return;
    }

    var addBtn = evt.target.closest('[data-lb-qv-add]');
    if (addBtn && !addBtn.disabled) {
      var variantId = addBtn.getAttribute('data-variant-id');
      if (variantId) addToCart([{ id: variantId, quantity: 1 }], addBtn);
      return;
    }

    var addLookBtn = evt.target.closest('[data-lb-qv-add-look]');
    if (addLookBtn) {
      var panel = addLookBtn.closest('.lb-qv-panel');
      if (!panel) return;
      var buttons = panel.querySelectorAll('[data-lb-qv-add]:not([disabled])');
      var items = [];
      buttons.forEach(function (b) {
        var id = b.getAttribute('data-variant-id');
        if (id) items.push({ id: id, quantity: 1 });
      });
      if (items.length) addToCart(items, addLookBtn);
    }
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key !== 'Enter' && evt.key !== ' ') return;
    var opener = evt.target.closest('[data-lb-qv-open]');
    if (opener) {
      evt.preventDefault();
      opener.click();
    }
  });
})();
